import {
  Checkbox,
  FormControlLabel,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";

interface HotkeySafeCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  sx?: SxProps<Theme>;
}

export const HotkeySafeCheckbox = ({
  checked,
  onChange,
  label,
  sx,
}: HotkeySafeCheckboxProps) => (
  <FormControlLabel
    control={
      <Checkbox
        size="small"
        checked={checked}
        onChange={(event) => {
          onChange(event.target.checked);
        }}
        // A focused checkbox swallows the labelling hotkeys.
        onFocus={(event) => {
          event.target.blur();
        }}
      />
    }
    label={
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    }
    onMouseDown={(event) => {
      event.preventDefault();
    }}
    sx={sx}
  />
);
